
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-environment",
      function () {
        return require("private-next-pages/learning-environment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-environment"])
      });
    }
  